import { type PropsWithChildren } from 'react'

import styles from './styles.module.scss'

export const PresetField = ({ children }: PropsWithChildren) => (
  <div className={styles.field}>{children}</div>
)
